/**
 * Stable form IDs for agreement/legal forms. Used by app and tests.
 */
export const FORM_IDS = {
  PRIVACY_POLICY: "genomic-life-privacy-policy",
  TERMS_AND_CONDITIONS: "genomic-life-terms-and-conditions",
  HIPAA_AUTHORIZATION: "genomic-life-hipaa-authorization",
  COLOGUARD_ACKNOWLEDGEMENT: "cologuard-acknowledgement-form"
} as const;

/** Member-facing order for agreement forms across onboarding and re-acceptance flows. */
export const AGREEMENT_FORM_PRESENTATION_ORDER = [
  FORM_IDS.TERMS_AND_CONDITIONS,
  FORM_IDS.PRIVACY_POLICY,
  FORM_IDS.HIPAA_AUTHORIZATION
] as const;

export type AgreementFormId =
  (typeof AGREEMENT_FORM_PRESENTATION_ORDER)[number];

export function isAgreementFormId(formId: string): formId is AgreementFormId {
  return (AGREEMENT_FORM_PRESENTATION_ORDER as readonly string[]).includes(
    formId
  );
}

export function sortFormTemplatesByPresentationOrder<T extends { id: string }>(
  forms: T[]
): T[] {
  const orderIndex = new Map<string, number>(
    AGREEMENT_FORM_PRESENTATION_ORDER.map((formId, index) => [formId, index])
  );

  return [...forms].sort((left, right) => {
    const leftIndex = orderIndex.get(left.id);
    const rightIndex = orderIndex.get(right.id);

    if (leftIndex === undefined && rightIndex === undefined) {
      return 0;
    }
    if (leftIndex === undefined) {
      return 1;
    }
    if (rightIndex === undefined) {
      return -1;
    }
    return leftIndex - rightIndex;
  });
}
